import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './NotFound.module.css';

const NotFound = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className={styles.notFoundPageContainer}>
      <h1 className={styles.notFoundPageErrorCode}>404</h1>
      <p className={styles.notFoundPageErrorMessage}>
        Unfortunately, the page you're looking for does not exist!
      </p>
      <button className={styles.notFoundPageHomeButton} onClick={handleBackToHome}>
        Back to Home
      </button>
    </div>
  );
};

export default NotFound;